import { format } from 'date-fns'

import { TableCell, TableRow } from '@percent/lemonade'
import { TruncatedList } from '@percent/domain/giving'
import { env } from '@percent/partner-dashboard/env'
import type { GivingCampaignPartnerDto } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'
import { ActionsMenu } from './ActionsMenu/ActionsMenu'
import { StatusBadge } from './StatusBadge'
import { TitleLink } from './TitleLink'
import styles from './CampaignsTableRow.module.scss'

export type CampaignsTableRowProps = Readonly<{
  campaign: GivingCampaignPartnerDto
}>

export function CampaignsTableRow({ campaign }: CampaignsTableRowProps) {
  const campaignHref = `${env.NX_PUBLIC_WPG_ADDRESS}/campaigns/${campaign.id}`
  const campaignEditHref = `${env.NX_PUBLIC_WPG_ADDRESS}/campaigns/${campaign.id}/edit`
  const formattedStartDate = campaign.startDate ? format(new Date(campaign.startDate), 'MMMM d, yyyy') : ''
  const formattedEndDate = campaign.endDate ? format(new Date(campaign.endDate), 'MMMM d, yyyy') : ''

  return (
    <TableRow key={campaign.id}>
      <TableCell>
        <TitleLink campaignHref={campaignHref} campaignTitle={campaign.title} />
      </TableCell>
      <TableCell>
        {formattedStartDate} - {formattedEndDate}
      </TableCell>
      <TableCell>
        <TruncatedList items={campaign.groups.map(g => g.name)} />
      </TableCell>
      <TableCell>
        <StatusBadge campaign={campaign} />
      </TableCell>
      <TableCell className={styles.actionsCell}>
        <ActionsMenu
          campaignId={campaign.id}
          campaignHref={campaignHref}
          campaignEditHref={campaignEditHref}
          campaignTitle={campaign.title}
          campaignStatus={campaign.status}
          campaignEndDate={campaign.endDate}
        />
      </TableCell>
    </TableRow>
  )
}
